/**
 * Centralized access to the PUBLIC frontend config. Everything here is shipped
 * in the browser bundle — never reference a secret. The API base URL differs
 * per environment (dev/staging/prod) and is provided via VITE_* at build time.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000',
  awsRegion: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
  cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '',
  cognitoUserPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '',
  isDev: import.meta.env.DEV,
} as const;

/** True once Cognito public ids are configured (gates real auth wiring). */
export const isCognitoConfigured = Boolean(
  env.cognitoUserPoolId && env.cognitoUserPoolClientId,
);
